/* eslint-disable max-classes-per-file */
import { GetExtendAvailabilityRequest } from '@numa-group/checkout-api';
import { AxiosInstance } from 'axios';

import { IAuthService } from '@src/features/auth/services/i-auth-service';
import { ExtendStayRepositoryMock } from '@src/mocks/repositories/extend-stay.repository.mock';

import { ExtendStayRepository } from './extend-stay.repository';
import { ExtendStayRepositoryAxios } from './extend-stay.repository.axios';

export class ExtendStayService {
  constructor(protected extendStayRepository: ExtendStayRepository) {}

  async getAvailabilityInfo(request: GetExtendAvailabilityRequest) {
    return this.extendStayRepository.getAvailabilityInfo(request);
  }

  public static create(axiosInstance: AxiosInstance, authService: IAuthService): ExtendStayService {
    const isMockEnabled = process.env.NEXT_PUBLIC_MOCKS_ACTIVE === 'true';

    const tripRepository = isMockEnabled
      ? new ExtendStayRepositoryMock(axiosInstance, authService)
      : new ExtendStayRepositoryAxios(axiosInstance, authService);

    return new ExtendStayService(tripRepository);
  }
}
